export const TelegramIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    filled?: boolean
  },
) =>
  props.filled ? (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.40636 13.2712C1.40636 13.2712 11.5789 9.10172 15.1092 7.63114C16.4645 7.04625 21.0488 5.16624 21.0488 5.16624C21.0488 5.16624 23.1653 4.34739 22.9896 6.34438C22.9311 7.16323 22.4626 10.0459 21.9941 13.1542C21.2914 17.5576 20.5218 22.3788 20.5218 22.3788C20.5218 22.3788 20.4047 23.7324 19.4008 23.9663C18.4053 24.2003 16.7573 23.1475 16.4645 22.9052C16.2302 22.7297 12.0558 20.0893 10.5249 18.7942C10.115 18.4433 9.64649 17.733 10.5834 16.9142C12.6999 14.9757 15.2264 12.5693 16.7573 11.0402C17.46 10.3383 18.171 8.6923 15.2264 10.6893C11.0519 13.5636 6.93603 16.2708 6.93603 16.2708C6.93603 16.2708 5.99908 16.8557 4.23393 16.3293C2.46879 15.8029 0.41085 15.0927 0.41085 15.0927C0.41085 15.0927 -1.00294 14.2153 1.41472 13.2712H1.40636Z"
        fill="currentColor"
      />
    </svg>
  ) : (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 4L2.75696 11.1692C2.31261 11.3537 2.091 11.4471 2.03362 11.5675C2.00876 11.6189 1.99736 11.6758 2.00051 11.7329C2.00366 11.79 2.02125 11.8453 2.05162 11.8937C2.12249 12.0062 2.35311 12.0737 2.81658 12.2098L9.31309 14.1244M20 4L17.677 18.6793C17.632 18.965 17.6095 19.1079 17.5341 19.1855C17.5023 19.2202 17.4635 19.2479 17.4203 19.2666C17.3771 19.2854 17.3304 19.295 17.2833 19.2947C17.1742 19.2947 17.0527 19.2137 16.8097 19.0517L13.5136 16.8513M20 4L9.31309 14.1244M9.31309 14.1244L9.48859 18.9617C9.48859 19.3374 9.48859 19.5253 9.56621 19.6198C9.6337 19.703 9.73495 19.7503 9.84294 19.7491C9.96668 19.748 10.1129 19.6276 10.4054 19.3891L13.5136 16.8513M9.31309 14.1244L13.5136 16.8513"
        stroke="currentColor"
        strokeWidth="1.34993"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
